import { format, isDate, parseISO } from 'date-fns';

export const formatDateWithDash = (date) => {
	try {
		return format(new Date(date), 'yyyy-MM-dd');
	} catch (error) {
		return '';
	}
};

export const calculateDaysDifference = (dateFromObj: Date, dateToObj: Date) => {
	return (dateToObj.getTime() - dateFromObj.getTime()) / (1000 * 60 * 60 * 24);
};

export const formatDateWithSlash = (date) => {
	try {
		return format(new Date(date), 'dd/MM/yyyy');
	} catch (error) {
		return '';
	}
};

export const formatCustomDate = (date, customFormat) => {
	try {
		return format(new Date(date), customFormat);
	} catch (error) {
		return '';
	}
};

export const formatDateWithTime = (date) => {
	try {
		return format(new Date(date), 'dd/MM/yyyy hh.mm a');
	} catch (error) {
		return '';
	}
};

export const formatDateWithPrevYear = (date) => {
	try {
		const dateData = new Date(date);
		const dateYear = dateData.getFullYear();
		const currentYear = new Date().getFullYear();

		const formatToUse = dateYear < currentYear ? 'MMM dd, yyyy' : 'MMM dd';

		return format(dateData, formatToUse);
	} catch (error) {
		return '';
	}
};

export const parseDateStringOnFormik = (value, originalValue) => {
	try {
		const parsedDate = isDate(originalValue) ? originalValue : parseISO(originalValue);
		return parsedDate;
	} catch (error) {
		console.error('Error date helper - parseDateStringOnFormik', error);
	}
};
